import { z } from "zod"
import { isOctopusIban } from "../utils/isOctopusIban"

export const ibanSchema = z.string().refine(
    (iban) => {
        if (!iban) return true

        return !isOctopusIban(iban)
    },
    { message: "IBAN invalide" }
)
